import React, { Dispatch } from 'react';
import { FormControl, Input, InputLabel, Button, Box, Typography } from '@mui/material';
import { DICTIONARY } from 'shared/constants';
import { confirmResetPassword } from 'aws-amplify/auth';

interface Props {
  dispatch: Dispatch<LoginAction>;
  state: LoginState;
}

const ConfirmNewPassword: React.FC<Props> = ({ dispatch, state }: Props) => {
  const {
    confirmError, newPassword, resetCode, username,
  } = state;

  const handleCancel = () => {
    dispatch({ type: 'cancel password reset' });
  };

  const handleConfirmSubmit = async () => {
    dispatch({ type: 'loading' });

    confirmResetPassword({ username, confirmationCode: resetCode, newPassword })
      .then(() => dispatch({ type: 'confirm success' }))
      .catch((error) => {
        dispatch({ type: 'confirm error', error: error.message });
      });
  };

  return (
    <>
      <Typography sx={{ marginBottom: '2rem' }} variant="h5" component="h1">
        {DICTIONARY.NewPasswordHeadline}
      </Typography>

      <Typography sx={{ lineHeight: 'normal', display: 'block', marginBottom: '16px' }}>
        {DICTIONARY.ResetCodePrompt}
      </Typography>

      {confirmError && (
        <Typography className="error-text">{confirmError}</Typography>
      )}

      <form onSubmit={handleConfirmSubmit}>
        <FormControl sx={{ marginBottom: '2rem', width: '100%' }}>
          <InputLabel htmlFor="code-input">{DICTIONARY.ResetCode}</InputLabel>
          <Input
            id="code-input"
            value={resetCode}
            onChange={(e) => dispatch({
              type: 'field',
              fieldName: 'resetCode',
              payload: e.currentTarget.value.trim(),
            })}
          />
        </FormControl>

        <FormControl sx={{ marginBottom: '2rem', width: '100%' }}>
          <InputLabel htmlFor="new-password-input">
            {DICTIONARY.NewPassword}
          </InputLabel>
          <Input
            id="new-password-input"
            value={newPassword}
            onChange={(e) => dispatch({
              type: 'field',
              fieldName: 'newPassword',
              payload: e.currentTarget.value.trim(),
            })}
            type="password"
          />
        </FormControl>

        <Box display="flex">
          <button
            className="button button--small"
            onClick={handleCancel}
            type="button"
          >
            {DICTIONARY.CancelReset}
          </button>
          <Button
            sx={{ marginLeft: 'auto' }}
            onClick={handleConfirmSubmit}
            color="primary"
            variant="contained"
          >
            {DICTIONARY.ResetPassword}
          </Button>
        </Box>
      </form>
    </>
  );
};

export default ConfirmNewPassword;
